<template>
  <div class="">
    <v-row>
      <v-col md="6" sm="12" v-if="history.length <= 0">
        <v-alert border="right" prominent type="info" color="#e16979" dark>
          There is no history of orders
        </v-alert>
      </v-col>
      <v-col md="12" sm="12">

        <v-data-table-header>Hello there</v-data-table-header>
        
        <v-data-table
          :headers="headers"
          :items="history"
          :items-per-page="15"
          group-by="user.last_name"
          show-group-by
          :loading ="loading"
          loading-text="Loading... Please wait"
        >
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";

export default {
  metaInfo: {
    title: "INCAB > Archive",
  },
  mounted() {
    axios.get("/api/v1/deleted_orders/").then((response) => {
      this.history = response.data;
      this.loading = false
      
    })
  },
  methods: {
    restore(id, index) {
      axios
        .patch(`/api/v1/orders/${id}/`, { status: "", state: 8 })
        .then((response) => {
          this.history.splice(index, 1);
        });
    },
    deleteTask(id, index) {
      axios.delete(`/api/v1/tasks/${id}/`).then((response) => {
        this.history.splice(index, 1);
      });
    },
  },

  data() {
    return {
      loading:true,
      history: [],
      headers:[
        { text: 'Id', value: 'id', sortable: false, align: 'start',groupable: false },
        { text: 'PO', value: 'name', sortable: false, align: 'start',groupable: false  },
        { text: 'User', value: 'user.last_name', align: 'start'  },
        { text: 'Link', value: 'link', sortable: false, align: 'start',groupable: false  },
      ]
    };
  },
};
</script>
